import { useEffect, useState } from "react";
import axios from "axios";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config.js";
import { Link, useSearchParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { CATEGORY_MAP } from "../json/categoryMap.js";
import { useUser } from "../config/userProvider.js";
import { getCookie } from "../config/webStorage.js";
import { DEPARTMENTS } from "../json/departments.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const DEPARTMENT_ROLES = [
  "delivery",
  "quality",
  "logistics",
  "warehouse",
  "finance",
];

const STATUS_COLORS = {
  new: "bg-blue-100 text-blue-700",
  open: "bg-indigo-100 text-indigo-700",
  in_progress: "bg-yellow-100 text-yellow-700",
  waiting_customer: "bg-orange-100 text-orange-700",
  escalated: "bg-red-100 text-red-700",
  resolved: "bg-green-100 text-green-700",
  closed: "bg-gray-200 text-gray-700",
  hold: "bg-purple-100 text-purple-700",
};
export function useDebounce(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debouncedValue;
}

export default function TicketList() {
  const token = getCookie("scspt");
  const { userData } = useUser();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedIds, setSelectedIds] = useState([]);
  //   const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);

  const [pagination, setPagination] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const [departmentFilter, setDepartmentFilter] = useState(
    searchParams.get("department") || "",
  );

  const [deptStatusFilter, setDeptStatusFilter] = useState(
    searchParams.get("departmentStatus") || "",
  );

  // const updateDateRange = (start, end) => {
  //   setFilters((prev) => ({
  //     ...prev,
  //     startDate: start ? start.toISOString() : prev.startDate,
  //     endDate: end ? end.toISOString() : prev.endDate,
  //   }));
  // };

  const formatStartDate = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return formatDateLocal(d);
  };

  const formatEndDate = (date) => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return formatDateLocal(d);
  };

  const formatDateLocal = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const updateDateRange = (start, end) => {
    setFilters((prev) => ({
      ...prev,
      startDate: start ? formatStartDate(start) : prev.startDate,
      endDate: end ? formatEndDate(end) : prev.endDate,
    }));
  };

  const [filters, setFilters] = useState({
    search: searchParams.get("search") || "",
    status: searchParams.get("status") || "",
    priority: searchParams.get("priority") || "",
    channel: searchParams.get("channel") || "",
    queue: searchParams.get("queue") || "",
    category: searchParams.get("category") || "",
    subcategory: searchParams.get("subcategory") || "",
    startDate: searchParams.get("startDate") || "",
    endDate: searchParams.get("endDate") || "",
    acptCategory: searchParams.get("acptCategory") || "",
    acptError: searchParams.get("acptError") || "",
    userObjId: searchParams.get("userObjId") || "",
  });

  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
  const [limit, setLimit] = useState(Number(searchParams.get("limit")) || 100);
  const debouncedSearch = useDebounce(filters.search, 600);

  const exportSelected = () => {
    const rows = tickets
      .filter((t) => selectedIds.includes(t._id))
      .map((t) => ({
        TicketID: t.ticketId,
        Customer: t.customer?.name,
        "Order ID": t.order?.orderId,
        // Phone: t.customer?.phone,
        Category: t.category,
        Subcategory: t.subcategory,
        Status: t.status,
        Priority: t.priority,
        Channel: t.channel,
        Queue: t.queue,
        CreatedAt: new Date(t.createdAt).toLocaleString(),
      }));

    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Tickets");

    const blob = new Blob(
      [XLSX.write(wb, { bookType: "xlsx", type: "array" })],
      { type: "application/octet-stream" },
    );

    saveAs(blob, "tickets.xlsx");
  };

  //   useEffect(() => {
  //     const params = {
  //       ...filters,
  //       search: debouncedSearch,
  //       page,
  //       limit,
  //     };

  //       // 🔐 Auto department scoping
  // if (
  //   userData &&
  //   DEPARTMENT_ROLES.includes(userData?.role)
  // ) {
  //   params.department = userData?.role;
  // }

  //     Object.keys(params).forEach((k) => (!params[k] ? delete params[k] : null));

  //     setSearchParams(params);
  //   }, [
  //     debouncedSearch,
  //     filters.status,
  //     filters.priority,
  //     filters.channel,
  //     filters.queue,
  //     filters.category,
  //     filters.subcategory,
  //     userData?.role,
  //     page,
  //     limit,
  //   ]);

  useEffect(() => {
    const params = {
      ...filters,
      search: debouncedSearch,
      page,
      limit,
    };

    // ❗ Only allow date filter when BOTH exist
    if (!filters.startDate || !filters.endDate) {
      delete params.startDate;
      delete params.endDate;
    }

    // 🔐 Department logic
    if (userData) {
      if (["admin", "master"].includes(userData.role)) {
        if (departmentFilter) params.department = departmentFilter;
      } else if (DEPARTMENT_ROLES.includes(userData.role)) {
        params.department = userData.role; // FORCE
      }
    }

    // 🧠 Department response status
    if (deptStatusFilter) {
      params.departmentStatus = deptStatusFilter;
    }

    Object.keys(params).forEach((k) => (!params[k] ? delete params[k] : null));

    setSearchParams(params);
  }, [
    debouncedSearch,
    filters,
    departmentFilter,
    deptStatusFilter,
    userData?.role,
    page,
    limit,
  ]);

  // const fetchTickets = async () => {
  //   setLoading(true);

  //   const params = Object.fromEntries([...searchParams]);

  //   // let params = Object.fromEntries([...searchParams]);

  //   // 🔐 FORCE department for non-admins (ALWAYS)
  //   // if (
  //   //   userData &&
  //   //   DEPARTMENT_ROLES.includes(userData.role)
  //   // ) {
  //   //   params.department = userData.role;
  //   // } else {
  //   //   delete params.department;
  //   // }

  //   const res = await axios.get(`${apiurl}/api/cst/get`, {
  //     params,
  //   });

  //   setTickets(res?.data?.tickets || []);
  //   setPagination(res?.data?.pagination || {});
  //   setLoading(false);
  // };

  const fetchTickets = async () => {
    setLoading(true);

    let params = Object.fromEntries([...searchParams]);

    // 🔐 HARD ENFORCEMENT (cannot be bypassed)
    if (userData && DEPARTMENT_ROLES.includes(userData.role)) {
      params.department = userData.role;
    }

    // ❌ Remove department filter if admin cleared it
    if (
      userData &&
      ["admin", "master"].includes(userData.role) &&
      !departmentFilter
    ) {
      delete params.department;
    }

    const res = await axios.get(`${apiurl}/api/cst/get`, { params });

    setTickets(res?.data?.tickets || []);
    setPagination(res?.data?.pagination || {});
    setLoading(false);
  };

  useEffect(() => {
    if (userData && DEPARTMENT_ROLES.includes(userData.role)) {
      setDepartmentFilter(""); // 🔒 UI reset
    }
  }, [userData?.role]);

  useEffect(() => {
    fetchTickets();
  }, [searchParams]);

  useEffect(() => {
    setPage(1);
  }, [
    debouncedSearch,
    filters.status,
    filters.priority,
    filters.channel,
    filters.queue,
    filters.category,
    filters.subcategory,
    filters.endDate,
    filters.startDate,
    departmentFilter,
    deptStatusFilter,
    userData?.role,
    filters.userObjId,
    filters.feedbackStatus,
  ]);

  console.log("selectedIds", selectedIds);

  useEffect(() => {
    setPage(1);
  }, [departmentFilter, deptStatusFilter]);

  const [showBulkDeptModal, setShowBulkDeptModal] = useState(false);
  const [showBulkStatusUpdateModal, setShowBulkStatusUpdateModal] =
    useState(false);
  const [bulkDepartment, setBulkDepartment] = useState("");
  const [bulkDueAt, setBulkDueAt] = useState("");
  const [bulkAssigning, setBulkAssigning] = useState(false);

  const [bulkStatus, setBulkStatus] = useState("");
  const [bulkUpdating, setBulkUpdating] = useState(false);

  const bulkAssignDepartment = async () => {
    if (!bulkDepartment) {
      alert("Select department");
      return;
    }

    setBulkAssigning(true);

    try {
      await axios.post(
        `${apiurl}/api/cst/assign-department-bulk`,
        {
          ticketObjIds: selectedIds,
          department: bulkDepartment,
          responseDueAt: new Date(Date.now() + 24 * 60 * 60 * 1000),
        },
        {
          headers: {
            Authorization: token,
          },
        },
      );

      setSelectedIds([]);
      setShowBulkDeptModal(false);
      await fetchTickets(); // refresh list
    } catch (err) {
      alert(err?.response?.data?.message || "Bulk assign failed");
    } finally {
      setBulkAssigning(false);
    }
  };

  const bulkUpdateStatus = async () => {
    if (!bulkStatus) {
      alert("Select status");
      return;
    }

    if (selectedIds.length === 0) {
      alert("No tickets selected");
      return;
    }

    setBulkUpdating(true);

    try {
      await axios.post(
        `${apiurl}/api/cst/bulk-update-status`,
        {
          ticketObjIds: selectedIds,
          status: bulkStatus,
          actor: {
            userObjId: userData?._id,
            userName: userData?.firstName + " " + userData?.lastName,
            department: userData?.department || userData?.role,
          },
        },
        {
          headers: {
            Authorization: token,
          },
        },
      );

      setSelectedIds([]);
      setShowBulkStatusUpdateModal(false);
      setBulkStatus("");

      await fetchTickets();
    } catch (err) {
      alert(err?.response?.data?.message || "Bulk update failed");
    } finally {
      setBulkUpdating(false);
    }
  };

  const STATUS_OPTIONS = [
    "new",
    "open",
    "in_progress",
    "waiting_customer",
    "escalated",
    "closed",
    "cancelled",
    "re_opened",
    "hold",
  ];

  const clearFilters = () => {
    setFilters({
      search: "",
      status: "",
      priority: "",
      channel: "",
      queue: "",
      category: "",
      subcategory: "",
      startDate: "",
      endDate: "",
      acptCategory: "",
      acptError: "",
    });

    setDepartmentFilter("");
    setDeptStatusFilter("");
    setPage(1);

    // clear URL params
    setSearchParams({});
  };

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedRole, setSelectedRole] = useState("");

  useEffect(() => {
    if (selectedRole) {
      fetchUsersByRole(selectedRole);
    }
  }, [selectedRole]);

  const fetchUsersByRole = async (role) => {
    try {
      const response = await axios.post(`${apiurl}/api/user/getbyrole`, {
        role,
      });

      if (response.data.success) {
        setUsers(response.data.users);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="bg-white rounded-2xl shadow p-2">
          {/* Header */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
            <h1 className="text-2xl font-semibold text-gray-800">Tickets</h1>

            <input
              placeholder="Search ticket, customer, order..."
              className="input"
              value={filters.search}
              onChange={(e) =>
                setFilters({ ...filters, search: e.target.value })
              }
            />

            {["admin", "master"].includes(userData?.userType) ? (
              <div className="flex justify-between items-center w-full gap-4">
                <button
                  disabled={selectedIds.length === 0}
                  onClick={() => setShowBulkStatusUpdateModal(true)}
                  className="px-4 py-2 w-50 bg-indigo-600 text-white rounded disabled:opacity-50"
                >
                  Update Status ({selectedIds.length})
                </button>
                <button
                  disabled={selectedIds.length === 0}
                  onClick={exportSelected}
                  className="px-4 py-2 bg-green-600 text-white rounded disabled:opacity-50"
                >
                  Export
                </button>

                <button
                  disabled={selectedIds.length === 0}
                  onClick={() => setShowBulkDeptModal(true)}
                  className="px-4 py-2 w-50 bg-indigo-600 text-white rounded disabled:opacity-50"
                >
                  Assign ({selectedIds.length})
                </button>
              </div>
            ) : null}
          </div>

          {showBulkDeptModal && (
            <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
              <div className="bg-white rounded-lg w-full max-w-md p-5">
                <h3 className="font-semibold text-lg mb-4">
                  Bulk Assign Department
                </h3>

                <div className="space-y-4">
                  <select
                    value={bulkDepartment}
                    onChange={(e) => setBulkDepartment(e.target.value)}
                    className="w-full border p-2 rounded"
                  >
                    <option value="">Select Department</option>
                    {DEPARTMENTS &&
                      DEPARTMENTS.map((d) => (
                        <option key={d} value={d}>
                          {d.toUpperCase()}
                        </option>
                      ))}
                  </select>

                  {/* <input
          type="datetime-local"
          value={bulkDueAt}
          onChange={(e) => setBulkDueAt(e.target.value)}
          className="w-full border p-2 rounded"
        /> */}

                  <div className="text-sm text-gray-500">
                    Tickets selected: {selectedIds.length}
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-6">
                  <button
                    onClick={() => setShowBulkDeptModal(false)}
                    className="px-4 py-2 border rounded"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={bulkAssignDepartment}
                    disabled={bulkAssigning}
                    className="px-4 py-2 bg-indigo-600 text-white rounded"
                  >
                    {bulkAssigning ? "Assigning..." : "Assign All"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {showBulkStatusUpdateModal && (
            <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
              <div className="bg-white rounded-lg w-full max-w-md p-5">
                <h3 className="font-semibold text-lg mb-4">
                  Bulk Update Status
                </h3>

                <div className="space-y-4">
                  <select
                    value={bulkStatus}
                    onChange={(e) => setBulkStatus(e.target.value)}
                    className="w-full border p-2 rounded"
                  >
                    <option value="">Select Status</option>
                    {STATUS_OPTIONS.map((s) => (
                      <option key={s} value={s}>
                        {s.replace("_", " ").toUpperCase()}
                      </option>
                    ))}
                  </select>

                  <div className="text-sm text-gray-500">
                    Tickets selected: {selectedIds.length}
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-6">
                  <button
                    onClick={() => setShowBulkStatusUpdateModal(false)}
                    className="px-4 py-2 border rounded"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={bulkUpdateStatus}
                    disabled={bulkUpdating}
                    className="px-4 py-2 bg-indigo-600 text-white rounded"
                  >
                    {bulkUpdating ? "Updating..." : "Update All"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Filters */}
          <div className="grid grid-cols-2 md:grid-cols-9 gap-1 mb-6">
            <Select
              label="Status"
              value={filters.status}
              onChange={(v) => setFilters({ ...filters, status: v })}
              options={[
                "new",
                "open",
                "in_progress",
                "waiting_customer",
                "escalated",
                "resolved",
                "closed",
                "hold",
              ]}
            />

            <Select
              label="Priority"
              value={filters.priority}
              onChange={(v) => setFilters({ ...filters, priority: v })}
              options={["low", "medium", "high", "critical"]}
            />

            {/* <Select
              label="Channel"
              value={filters.channel}
              onChange={(v) => setFilters({ ...filters, channel: v })}
              options={[
                "website",
                "mobile-app",
                "whatsapp",
                "email",
                "call-center",
                "admin",
              ]}
            />

            <Select
              label="Queue"
              value={filters.queue}
              onChange={(v) => setFilters({ ...filters, queue: v })}
              options={[
                "unassigned",
                "priority",
                "refund",
                "delivery",
                "technical",
              ]}
            /> */}
            <Select
              label="Category"
              value={filters.category}
              onChange={(v) =>
                setFilters({
                  ...filters,
                  category: v,
                  subcategory: "", // reset subcategory
                })
              }
              options={Object.keys(CATEGORY_MAP)}
              renderLabel={(key) => CATEGORY_MAP[key].label}
            />
            {filters.category &&
              CATEGORY_MAP[filters.category]?.subs?.length > 0 && (
                <Select
                  label="Subcategory"
                  value={filters.subcategory}
                  onChange={(v) => setFilters({ ...filters, subcategory: v })}
                  options={CATEGORY_MAP[filters.category].subs.map(
                    (s) => s.key,
                  )}
                  renderLabel={(key) =>
                    CATEGORY_MAP[filters.category].subs.find(
                      (s) => s.key === key,
                    )?.label
                  }
                />
              )}

            {/* 🔹 Admin / Master only */}
            {["admin", "master"].includes(userData?.userType) && (
              <Select
                label="Department"
                value={departmentFilter}
                onChange={setDepartmentFilter}
                options={DEPARTMENTS}
              />
            )}

            {/* 🔹 Department response status */}
            <Select
              label="Dept Status"
              value={deptStatusFilter}
              onChange={setDeptStatusFilter}
              options={["pending", "in_progress", "responded", "no_response"]}
            />

            <Select
              label="ACPT Category"
              value={filters.acptCategory}
              onChange={(v) =>
                setFilters({
                  ...filters,
                  acptCategory: v,
                  acptError: "", // reset error when category changes
                })
              }
              options={[
                "incomplete-or-incorrect-information",
                "fake-order-or-fake-commitment",
                "miss-punch-or-wrong-product-punch",
                "refund-or-return-policy-error",
                "price-manipulation",
                "other",
              ]}
            />
            <Select
              label="ACPT Error"
              value={filters.acptError}
              onChange={(v) =>
                setFilters({
                  ...filters,
                  acptError: v,
                })
              }
              options={["agent", "customer", "technical", "proocess"]}
            />

              <Select
              label="Feedback Status"
              value={filters.feedbackStatus}
              onChange={(v) => setFilters({ ...filters, feedbackStatus: v })}
              options={[
                "pending",
                "received",
              ]}
            />
            <div className="input capitalized text-sm border border-red-300 text-red-600 rounded-lg hover:bg-red-50 transition">
              <button
                onClick={clearFilters}
                className=""
              >
                Clear Filters
              </button>
            </div>
          </div>
          {/* Table */}
          <div className="flex items-center justify-between my-2">
            <p className="text-sm text-gray-500">
              Page {pagination.currentPage} of {pagination.totalPages} —{" "}
              {pagination.totalTickets} tickets
            </p>
            

            <div className="flex gap-2">
              {["admin", "master"].includes(userData?.userType) ? (
                <>
                  <select
                    className="p-2 border rounded"
                    onChange={(e) => setSelectedRole(e.target.value)}
                    value={selectedRole}
                  >
                    <option value="">Select Role</option>
                    <option value="customer-support">customer-support</option>
                    <option value="quality">quality</option>
                    <option value="logistics">logistics</option>
                    <option value="warehouse">warehouse</option>
                  </select>
                  <select
                    className="p-2 border rounded"
                    value={selectedUser}
                    disabled={!users.length}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedUser(value);

                      setFilters((prev) => ({
                        ...prev,
                        userObjId: value,
                      }));
                    }}
                  >
                    <option value="">Select User</option>
                    {users.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.firstName} {user.lastName}
                      </option>
                    ))}
                  </select>
                </>
              ) : null}
              <div className="flex">
                {/* <label className="block text-sm mb-1">Start Date</label> */}
                <DatePicker
                  selected={
                    filters.startDate ? new Date(filters.startDate) : null
                  }
                  onChange={(date) =>
                    updateDateRange(
                      date,
                      filters.endDate ? new Date(filters.endDate) : null,
                    )
                  }
                  selectsStart
                  startDate={
                    filters.startDate ? new Date(filters.startDate) : null
                  }
                  endDate={filters.endDate ? new Date(filters.endDate) : null}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="DD/MM/YYYY"
                  className="p-2 border rounded w-full"
                />
              </div>

              <div className="flex">
                {/* <label className="block text-sm mb-1">End Date</label> */}
                <DatePicker
                  selected={filters.endDate ? new Date(filters.endDate) : null}
                  onChange={(date) =>
                    updateDateRange(
                      filters.startDate ? new Date(filters.startDate) : null,
                      date,
                    )
                  }
                  selectsEnd
                  startDate={
                    filters.startDate ? new Date(filters.startDate) : null
                  }
                  endDate={filters.endDate ? new Date(filters.endDate) : null}
                  minDate={
                    filters.startDate ? new Date(filters.startDate) : null
                  }
                  dateFormat="dd/MM/yyyy"
                  placeholderText="DD/MM/YYYY"
                  className="p-2 border rounded w-full"
                />
              </div>

              <button
                className="text-sm button text-red-600 border px-2 rounded"
                onClick={() =>
                  setFilters((prev) => ({
                    ...prev,
                    startDate: "",
                    endDate: "",
                  }))
                }
              >
                Clear dates
              </button>
              <select
                className="border rounded"
                value={limit}
                onChange={(e) => setLimit(Number(e.target.value))}
              >
                {[100, 500, 1000, 2000].map((n) => (
                  <option key={n} value={n}>
                    {n} / page
                  </option>
                ))}
              </select>
              <button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Prev
              </button>

              <button
                disabled={page === pagination.totalPages}
                onClick={() => setPage(page + 1)}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-gray-600">
                <tr>
                  <th className="px-4 py-3">
                    <input
                      type="checkbox"
                      checked={
                        tickets.length > 0 &&
                        selectedIds.length === tickets.length
                      }
                      onChange={(e) =>
                        setSelectedIds(
                          e.target.checked ? tickets.map((t) => t._id) : [],
                        )
                      }
                    />
                  </th>

                  <th className="px-4 py-3 text-left">Ticket</th>
                  <th className="px-4 py-3">Order ID</th>
                  <th className="px-4 py-3">Priority</th>
                  <th className="px-4 py-3">Customer</th>
                  <th className="px-4 py-3">Category</th>
                  <th className="px-4 py-3">Status</th>
                  <th className="px-4 py-3">Created By</th>
                  {/* <th className="px-4 py-3">Assignee</th> */}
                  <th className="px-4 py-3">Deduction</th>
                  <th className="px-4 py-3">Dept Status</th>
                  <th className="px-4 py-3">SLA</th>
                  <th className="px-4 py-3">Rating</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="text-center py-10">
                      Loading tickets...
                    </td>
                  </tr>
                ) : tickets.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center py-10">
                      No tickets found
                    </td>
                  </tr>
                ) : (
                  tickets.map((t) => {
                    const activeDept = ["admin", "master"].includes(
                      userData?.role,
                    )
                      ? departmentFilter
                      : userData?.role;

                    const deptAction = t.departmentActions?.find(
                      (d) => d.department === activeDept,
                    );

                    console.log("deptAction", deptAction);
                    return (
                      <tr
                        key={t._id}
                        className="border-b hover:bg-gray-50 cursor-pointer"
                      >
                        <td className="px-4 py-3">
                          <input
                            type="checkbox"
                            checked={selectedIds.includes(t._id)}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => {
                              setSelectedIds((prev) =>
                                e.target.checked
                                  ? [...prev, t._id]
                                  : prev.filter((id) => id !== t._id),
                              );
                            }}
                          />
                        </td>

                        <td
                          className="px-4 py-3"
                          // onClick={() =>
                          //   (window.location.href = `/tickets/${t._id}`)
                          // }
                        >
                          <Link
                            target="_blank"
                            to={`/tickets/${t._id}`}
                            className="font-medium text-indigo-600"
                          >
                            #{t.ticketId}
                          </Link>
                          <div className="text-xs text-gray-500">
                            {new Date(t.createdAt).toLocaleString()}
                          </div>
                        </td>

                        <td className="px-4 py-3">
                          <div className="font-medium">{t.order?.orderId}</div>
                          <div className="text-xs text-gray-500">
                            {/* {t.customer?.phone} */}
                          </div>
                        </td>

                        <td className="px-4 py-3 capitalize">
                          <span
                            className={`px-2 py-1 border-l-4 rounded-r ${
                              t.priority === "high"
                                ? "bg-red-100 text-red-600 border-red-500"
                                : t.priority === "medium"
                                  ? "bg-yellow-100 text-yellow-700 border-yellow-500"
                                  : t.priority === "critical"
                                    ? "bg-red-200 text-red-800 border-red-700"
                                    : t.priority === "low"
                                      ? "bg-blue-100 text-green-700 border-green-500"
                                      : "bg-gray-100 text-gray-700 border-gray-500"
                            }`}
                          >
                            {t.priority}
                          </span>
                        </td>

                        <td className="px-4 py-3 text-center">
                          <div className="font-medium">{t.customer?.name}</div>
                          <div className="text-xs text-gray-500">
                            {/* {t.customer?.phone} */}
                          </div>
                        </td>

                        {/* <td className="px-4 py-3">
                        <div>{t.category}</div>
                        <div className="text-xs text-gray-500">
                          {t.subcategory}
                        </div>
                      </td> */}

                        <td className="px-4 py-3">
                          <div>
                            {CATEGORY_MAP[t.category]?.label || t.category}
                          </div>
                          <div className="text-xs text-gray-500">
                            {
                              CATEGORY_MAP[t.category]?.subs.find(
                                (s) => s.key === t.subcategory,
                              )?.label
                            }
                          </div>
                        </td>

                        <td className="px-4 py-3">
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-medium ${
                              STATUS_COLORS[t.status] ||
                              "bg-gray-100 text-gray-700"
                            }`}
                          >
                            {t.status.replace("_", " ")}
                          </span>
                        </td>

                        <td className="px-4 py-3">
                          {t.createdBy?.userName || (
                            <span className="text-gray-400">Unknown</span>
                          )}
                        </td>
                        {/* <td className="px-4 py-3">
                          {t.assignee?.userName || (
                            <span className="text-gray-400">Unassigned</span>
                          )}
                        </td> */}
                        <td className="px-4 py-3">
                          {t?.conductDetails?.conductObjId ? (
                            <span className="text-white rounded-md bg-red-600 px-2 py-1">
                              {t?.conductDetails?.deductionAmount}
                            </span>
                          ) : (
                            "N/A"
                          )}
                        </td>

                        {/* <td className="px-4 py-3">
                          {deptAction ? (
                            <span
                              className={`px-2 py-1 rounded-full text-xs font-medium ${
                                deptAction.status === "responded"
                                  ? "bg-green-100 text-green-700"
                                  : deptAction.status === "no_response"
                                    ? "bg-red-100 text-red-700"
                                    : "bg-yellow-100 text-yellow-700"
                              }`}
                            >
                              {deptAction.status.replace("_", " ")}
                            </span>
                          ) : (
                            <span className="text-gray-400 text-xs">—</span>
                          )}
                        </td> */}
                        {/* 
                        <td className="px-4 py-3">
  {t.departmentActions?.length > 0 ? (
    t.departmentActions
      .filter((dept) => dept.status === "responded")
      .length > 0 ? (
      <div className="flex flex-wrap gap-1">
        {t.departmentActions
          .filter((dept) => dept.status === "responded")
          .map((dept) => (
            <span
              key={dept._id}
              className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700"
            >
             {dept.department} - {dept.status.replace("_", " ")}
            </span>
          ))}
      </div>
    ) : (
      <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">
        Pending
      </span>
    )
  ) : (
    <span className="text-gray-400 text-xs">—</span>
  )}
</td> */}
                        <td className="px-4 py-3">
                          {t.departmentActions?.length > 0 ? (
                            (() => {
                              const respondedDepts = t.departmentActions.filter(
                                (dept) => dept.status === "responded",
                              );

                              if (respondedDepts.length > 0) {
                                return (
                                  <div className="flex flex-wrap gap-1">
                                    {respondedDepts.map((dept) => (
                                      <span
                                        key={dept._id}
                                        className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700"
                                      >
                                        {dept.department} - responded
                                      </span>
                                    ))}
                                  </div>
                                );
                              }

                              return (
                                <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">
                                  Pending
                                </span>
                              );
                            })()
                          ) : (
                            <span className="text-gray-400 text-xs">—</span>
                          )}
                        </td>

                        <td className="px-4 py-3">
                          {t.sla?.breached ? (
                            <span className="text-red-600 font-semibold">
                              Breached
                            </span>
                          ) : (
                            <span className="text-green-600">OK</span>
                          )}
                        </td>
                        <td className="px-4 py-3">
                          {t?.csat?.feedbackStatus === "received"? (
                            <span className="text-yellow-600 font-semibold">
                              {t.csat.rating} / 5
                            </span>
                          ) : (
                            <span className="text-gray-400">No rating</span>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Input styles */}
        <style jsx>{`
          .input {
            width: 100%;
            padding: 0.65rem 0.9rem;
            border: 1px solid #e5e7eb;
            border-radius: 0.75rem;
            font-size: 0.9rem;
          }
          .input:focus {
            border-color: #6366f1;
            outline: none;
            box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
          }
        `}</style>
      </Container>
    </Layout>
  );
}

function Select({ label, value, onChange, options, renderLabel }) {
  return (
    <select
      className="input capitalize"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">{label}</option>

      {options.map((opt) => (
        <option key={opt} value={opt}>
          {renderLabel ? renderLabel(opt) : opt.replace("_", " ")}
        </option>
      ))}
    </select>
  );
}